// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

function Box(Props) {
  let title = Props.title;
  let className = Props.className;
  let children = Props.children;
  return JsxRuntime.jsxs("div", {
    children: [
      title !== undefined ? JsxRuntime.jsx(Buhta_components__Text.H2.make, {
          className: "mb-2 animate-fadeIn",
          children: title
        }) : null,
      JsxRuntime.jsx("div", {
        children: children
      })
    ],
    className: Cn.fromList({
      hd: "p-6 sm:p-10 bg-white rounded-md shadow-sm",
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    })
  });
}

const make = Box;

export {
  make,
}
/* Buhta_components__Text Not a pure module */
